import { webKnots } from 'src/features/brands/atoms/canvas/common/back/lace/webKnots'
import { jointOfCatchFace, jointOfIndexFinger, jointOfThumbFinger2 } from './parts/earJointParts'
import { topSidePartOfWebForPicher } from './parts/sideParts'
import { generateLiningsGradient } from 'src/util/canvas'
import { allowLace2 } from '../lace/allowCenterOfCrossWeb'

export const w37Web = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  // web先端の革パーツ\
  topSidePartOfWebForPicher(ctx, webColor, laceColor, stitchColor)
  // ウェブ-人差し指のジョイントパーツ
  jointOfIndexFinger(ctx, webColor, laceColor, 3, 30)
  jointOfIndexFinger(ctx, webColor, laceColor, -24, 90)
  jointOfIndexFinger(ctx, webColor, laceColor, -45, 160)
  jointOfCatchFace(ctx, webColor, laceColor, -10, 12)
  jointOfCatchFace(ctx, webColor, laceColor, 38, 57)
  jointOfThumbFinger2(ctx, webColor, laceColor, 53, -56)
  jointOfThumbFinger2(ctx, webColor, laceColor, 19, -30)
  jointOfThumbFinger2(ctx, webColor, laceColor, -18, -5)
  // web本体のflatパーツ
  ctx.fillStyle = webColor
  ctx.beginPath()
  ctx.moveTo(549, 81) // 左上
  ctx.quadraticCurveTo(502, 166, 482, 247) // 左下1
  ctx.quadraticCurveTo(480, 256, 486, 268) // 左下2
  ctx.quadraticCurveTo(516, 326, 565, 357) // 右下1
  ctx.quadraticCurveTo(571, 362, 582, 362) // 右下2
  ctx.quadraticCurveTo(637, 324, 693, 280) // 右上
  ctx.quadraticCurveTo(660, 140, 549, 81) // 左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  const coordinates = { x0: 150, y0: 300, x1: 700, y1: 400 }
  const gradient = generateLiningsGradient(ctx, webColor, coordinates)

  // web上のデザイン 左上
  ctx.fillStyle = gradient
  ctx.beginPath()
  ctx.moveTo(569, 93) // 左上
  ctx.quadraticCurveTo(600, 126, 520, 196)
  ctx.quadraticCurveTo(617, 172, 618, 134)
  ctx.quadraticCurveTo(600, 110, 569, 93)
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.strokeStyle = '#fff'
  ctx.beginPath()
  ctx.moveTo(571, 93) // 左上
  ctx.quadraticCurveTo(602, 126, 525, 193)
  ctx.moveTo(616, 133) // 右上
  ctx.quadraticCurveTo(615, 171, 525, 193)
  ctx.stroke()
  ctx.closePath()

  // // web上のデザイン
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = gradient
  ctx.beginPath()
  ctx.moveTo(669, 297) // 上＿右
  ctx.quadraticCurveTo(608, 308, 538, 294)
  ctx.quadraticCurveTo(587, 329, 629, 330)
  ctx.quadraticCurveTo(669, 297, 669, 297)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.strokeStyle = '#fff'
  ctx.beginPath()
  ctx.moveTo(669, 299) // 上＿右
  ctx.quadraticCurveTo(608, 308, 542, 296)
  ctx.quadraticCurveTo(587, 326, 628, 328)
  ctx.stroke()
  ctx.closePath()
  ctx.strokeStyle = '#282828'

  ctx.fillStyle = gradient
  ctx.beginPath()
  ctx.moveTo(531, 329) // 左上
  ctx.quadraticCurveTo(563, 342, 582, 333)
  ctx.quadraticCurveTo(577, 349, 557, 355)
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // ctx.fillStyle = webColor
  ctx.strokeStyle = '#fff'
  ctx.beginPath()
  ctx.moveTo(531, 331) // 左上
  ctx.quadraticCurveTo(563, 344, 580, 335)
  ctx.quadraticCurveTo(573, 348, 554, 353)
  // ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // ウェブ上のデザイン // 中央のレース
  ctx.beginPath()
  ctx.strokeStyle = '#282828'
  ctx.moveTo(524, 241)
  ctx.quadraticCurveTo(647, 233, 647, 233) //
  // ctx.quadraticCurveTo() //
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 外側
  ctx.moveTo(552, 87) // 左上
  ctx.quadraticCurveTo(508, 166, 485, 252) // 左下
  ctx.quadraticCurveTo(495, 284, 528, 323) // // 中央下
  ctx.quadraticCurveTo(562, 340, 585, 329) //
  ctx.quadraticCurveTo(578, 350, 565, 355) // 右下
  ctx.quadraticCurveTo(581, 364, 620, 332) // 右下_上
  ctx.quadraticCurveTo(565, 325, 530, 289) //
  ctx.quadraticCurveTo(617, 305, 671, 294) //
  ctx.quadraticCurveTo(690, 279, 690, 279) // 右上
  ctx.quadraticCurveTo(668, 189, 619, 140) //
  ctx.quadraticCurveTo(611, 181, 514, 198) //
  ctx.quadraticCurveTo(594, 129, 566, 94) //
  ctx.quadraticCurveTo(552, 87, 552, 87) //

  // 内側
  ctx.moveTo(554, 89) // 左上
  ctx.quadraticCurveTo(513, 164, 489, 252) // 左下
  ctx.quadraticCurveTo(495, 282, 529, 322) // // 中央下
  // 右下
  ctx.moveTo(567, 354) // 左上
  ctx.quadraticCurveTo(584, 357, 614, 334) //

  // 右上
  ctx.moveTo(664, 296) // 左上
  ctx.quadraticCurveTo(688, 279, 688, 279) // 右上

  // レース周り
  ctx.moveTo(521, 238) // 左上
  ctx.quadraticCurveTo(649, 230, 649, 230) // 右上
  ctx.quadraticCurveTo(655, 235, 648, 237) // 右下
  ctx.quadraticCurveTo(521, 245, 521, 245) //
  ctx.quadraticCurveTo(516, 241, 521, 238) //
  // ctx.quadraticCurveTo() //

  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで
  webKnots(ctx, laceColor, -110, 110, 1) // ウェブ先端寄りのウェブ結び目
  allowLace2(ctx, laceColor, 15, -336, 35, 1)
  allowLace2(ctx, laceColor, 0, -323, 35, 1)
  allowLace2(ctx, laceColor, -15, -312, 35, 1)
  allowLace2(ctx, laceColor, -30, -300, 35, 1)
  allowLace2(ctx, laceColor, -45, -288, 35, 1)
  allowLace2(ctx, laceColor, -60, -276, 35, 1)
  webKnots(ctx, laceColor, -115, 20, 1) // ウェブ先端寄りのウェブ結び目
}
